const React = require("react")
const { kebabCase } = require("lodash/string")

export default ({ primary }) => <div id={kebabCase(primary.tableOfContentsHeader)} />
